import React, { useEffect, useRef } from 'react';   

// 5. Concentric Rings (unchanged)
const HomeServicesConcentric = () => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const setupConcentricRings = () => {
      const container = containerRef.current;
      if (!container) return;
      
      container.innerHTML = "";
      const canvas = document.createElement("canvas");
      // Double the size and use high DPI for crisp rendering
      const size = 360;
      const dpr = window.devicePixelRatio || 1;
      canvas.width = size * dpr;
      canvas.height = size * dpr;
      canvas.style.width = size + "px";
      canvas.style.height = size + "px";
      canvas.style.position = "absolute";
      canvas.style.left = "0";
      canvas.style.top = "0";
      container.appendChild(canvas);
      
      const ctx = canvas.getContext("2d");
      ctx.scale(dpr, dpr); // Scale for high DPI
      const centerX = size / 2;
      const centerY = size / 2;
      let time = 0;
      let lastTime = 0;
      
      // Ring parameters - match orbital sizing
      const ringCount = 6;
      const maxRadius = 130;

      const animate = (timestamp) => {
        if (!lastTime) lastTime = timestamp;
        const deltaTime = timestamp - lastTime;
        lastTime = timestamp;
        time += deltaTime * 0.001;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // Draw center dot - larger and more HD
        ctx.beginPath();
        ctx.arc(centerX, centerY, 6, 0, Math.PI * 2);
        ctx.fillStyle = "rgba(255, 255, 255, 0.95)";
        ctx.fill();
        
        // Draw concentric rings of dots
        for (let r = 0; r < ringCount; r++) {
          const radius = ((r + 1) / ringCount) * maxRadius;
          const dotCount = 8 + r * 8; // More dots in outer rings
          // Phase offset for rotation based on ring index
          const phaseOffset = r % 2 === 0 ? time * 0.2 : -time * 0.2;
          // Each ring pulses at a different phase
          const ringPhase = time + r * 0.7;
          
          for (let i = 0; i < dotCount; i++) {
            const angle = (i / dotCount) * Math.PI * 2 + phaseOffset;
            // Add a pulsing effect to the radius (slight)
            const radiusPulse = Math.sin(ringPhase) * 4; // Match orbital subtlety
            const finalRadius = radius + radiusPulse;
            const x = centerX + Math.cos(angle) * finalRadius;
            const y = centerY + Math.sin(angle) * finalRadius;
            // Enhanced dot size pulsing - more pronounced
            // Base size that varies by ring position
            const baseSize = 4 + r / (ringCount - 1) * 2; // Larger base size
            // Size pulse effect - dots get smaller at minimum, keeping max size unchanged
            const sizePulse = Math.sin(ringPhase) * baseSize * 0.08 + baseSize * 0.7;
            // Enhanced opacity pulsing - max 90%
            const opacityPulse = 0.6 + Math.sin(ringPhase) * 0.3;
            
            ctx.beginPath();
            ctx.arc(x, y, sizePulse, 0, Math.PI * 2);
            ctx.fillStyle = `rgba(255, 255, 255, ${opacityPulse})`;
            ctx.fill();
          }
        }
        
        animationRef.current = requestAnimationFrame(animate);
      };
      
      animationRef.current = requestAnimationFrame(animate);
    };

    setupConcentricRings();

    // Cleanup function
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="animation-container">
      <div ref={containerRef} className="circle-container"></div>
    </div>
  )
}

export default HomeServicesConcentric;
